import ApiService from '@/common/api.service';

const url = '/v1/investigators';

const InvestigatorService = {
  query(filters) {
    let params = {};

    Object.keys(filters).forEach(key => {
      params[key] = filters[key];
    });

    return ApiService.query(url, { params: params });
  },
  search(param) {
    return ApiService.get(`${url}`, `search?filter[name]=${param}`);
  }
};

export default InvestigatorService;
